var map = {
	"./de/impressum.mdx": [
		84008,
		84008
	],
	"./de/index.mdx": [
		4537,
		4537
	],
	"./de/rechtliche-grundlagen.mdx": [
		43926,
		43926
	],
	"./en/imprint.mdx": [
		13042,
		13042
	],
	"./en/index.mdx": [
		23697,
		23697
	],
	"./en/legal-framework.mdx": [
		68697,
		68697
	],
	"./fr/cadre-juridique.mdx": [
		63548,
		63548
	],
	"./fr/impressum.mdx": [
		87321,
		87321
	],
	"./fr/index.mdx": [
		32308,
		32308
	],
	"./it/colophon.mdx": [
		35827,
		35827
	],
	"./it/index.mdx": [
		34971,
		34971
	],
	"./it/quadro-giuridico.mdx": [
		96083,
		96083
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70227;
module.exports = webpackAsyncContext;